export default function Essay() {
  return (
    <div style={{ padding: "30px" }}>
      <h1>Essay</h1>
    </div>
  );
}